<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn :class="btnClass" :small="small" icon v-on="on" link target="_blank" :href="link">
        <v-icon :small="small">mdi-help-circle</v-icon>
      </v-btn>
    </template>
    <span>
      {{ label }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    link: String,
    label: {
      type: String,
      default: 'Ajuda',
    },
    btnClass: {
      type: String,
      default: 'mb-3 ml-2',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
